require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/socialtravel/shared/~/core-js/library/fn/array/from.js
// module id = 168
// module chunks = 0 1 2 3